/**
 * 用户管理 API
 */

import { http } from '../request';
import type { UserParams, UserListResponse, UserQueryParams } from '../../types/user';

/**
 * 分页查询用户列表
 */
export function getUserPage(params?: UserQueryParams): Promise<UserListResponse> {
  return http.get<UserListResponse>('/system/user/page', params);
}

/**
 * 根据 ID 查询用户详情
 */
export function getUserById(id: number): Promise<UserParams> {
  return http.get<UserParams>(`/system/user/${id}`);
}

/**
 * 创建用户
 */
export function createUser(data: UserParams): Promise<void> {
  return http.post('/system/user', data);
}

/**
 * 更新用户
 */
export function updateUser(data: UserParams): Promise<void> {
  // 后端 @PutMapping 不带路径变量，请求体需要包含 id
  return http.put('/system/user', data);
}

/**
 * 删除用户
 */
export function deleteUser(id: number): Promise<void> {
  return http.delete(`/system/user/${id}`);
}

/**
 * 获取用户的角色 ID 列表
 */
export function getUserRoles(id: number): Promise<number[]> {
  return http.get<number[]>(`/system/user/${id}/roles`);
}

/**
 * 分配用户角色
 */
export function assignUserRoles(id: number, roleIds: number[]): Promise<void> {
  return http.put(`/system/user/${id}/roles`, roleIds);
}

/**
 * 重置用户密码
 */
export function resetUserPassword(id: number): Promise<void> {
  return http.put(`/system/user/${id}/password/reset`);
}
